import React from 'react'

export const EducationLevels = [
  {
    name: 'list',
    component: React.lazy(() => import('modules/admin/general-parameters/educationLevels/EducationLevelsList')),
    path: '/admin/general-parameters/education-levels',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() => import('modules/admin/general-parameters/educationLevels/EducationLevelsCreate')),
    path: '/admin/general-parameters/education-levels/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'edit',
    component: React.lazy(() => import('modules/admin/general-parameters/educationLevels/EducationLevelsEdit')),
    path: '/admin/general-parameters/education-levels/edit/:educationLevelId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
